module.exports = __webpack_public_path__ + "img/couples-073.4e57c17b.jpg";